import React from 'react';
import ReportViewer from "./base/ReportViewer";

const TauxOccupation = () => {

    return (
        <div style={{ height: "100%" }}>
            <ReportViewer reportName={"Tauxoccupationreport"} />
        </div>
    );
}
export default TauxOccupation;